import { render, staticRenderFns } from "./newsView.vue?vue&type=template&id=52dc3a7e&scoped=true"
import script from "./newsView.vue?vue&type=script&lang=js"
export * from "./newsView.vue?vue&type=script&lang=js"
import style0 from "./newsView.vue?vue&type=style&index=0&id=52dc3a7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dc3a7e",
  null
  
)

export default component.exports